<template>
  <div class="photograph" v-loading="isLoading" :style="{ width: videoWidth + 32 + 'px' }">
    <slot name="title">
      <span>{{title}}</span>
    </slot>
    <div :style="{height: videoHeight + 15 + 'px' }">
     <el-upload
      v-if="!videoMode"
      class="photo-uploader"
      :style="{height: videoHeight + 'px', width: videoWidth + 'px' }"
      :action="host + uploadUrl"
      :headers="headers"
      :data="formData"
      :show-file-list="false"
      :accept="isMB?'image/*':'.jpg,.png,.jpeg'"
      :on-success="onSuccess"
      :before-upload="beforePhotoUpload">
      <img v-if="value" :src="host + '/api' + value" :style="{height: videoHeight + 'px', width: videoWidth + 'px' }">
      <div v-else style="flex: 1;">
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <p v-if="isMB">点击拍摄照片</p>
        <p v-else>点击上传图片</p>
      </div>
    </el-upload>
    </div>
    <video :id="videoId" v-show="videoMode" :width="videoWidth" :height="videoHeight" autoplay class="videoPosition"></video>
    <canvas class="videoPosition" v-show="videoMode&&toke" :id="canvasId" :width="videoWidth" :height="videoHeight" ></canvas>

    <el-button type="primary" @click="getCompetence" v-if="!isMB&&!videoMode" :disabled="openDisabled">打开摄像头</el-button>
    <el-button type="primary" @click="stopNavigator" v-else-if="!isMB">关闭摄像头</el-button>
    <el-button type="success" @click="setImage" v-if="videoMode&&!toke&&!isMB">拍照</el-button>
    <el-button type="danger" @click="delCert" v-else-if="value">删除</el-button>
  </div>
</template>
<script>
export default {
  computed: {
    host() {
      return window.location.origin;
    }
  },
  props: {
    value: {},
    title: {
      type: String,
      default: "证件照"
    },
    videoWidth: {
      type: Number,
      default: 160
    },
    videoHeight: {
      type: Number,
      default: 200
    },
    sizeLimit: {
      type: Boolean,
      default: false
    },
    uploadUrl: {
      type: String,
      default: '/api/Common/UploadPicture'
    },
    uploadApi: {
      type: String,
      default: 'stUploadFace'
    },
    formData: {
      type: Object,
      default: () => {}
    },
    openDisabled: {
      type: Boolean,
      default: false
    },
    canvasId: {
      type: String,
      default: "canvasCamera"
    },
    videoId: {
      type: String,
      default: "videoCamera"
    },
  },
  watch: {
    videoMode(v) {
      this.$emit("set-dis",v);
    }
  },
  data() {
    return {
      api: require("@/api/common/common").default,
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      videoMode: false,
      toke: false,
      headers: { Authorization: "" },
      isLoading: false,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    getCompetence () {
      this.$emit('open-video');
      var _this = this;
      this.thisCancas = document.getElementById(this.canvasId);
      this.thisContext = this.thisCancas.getContext('2d');
      this.thisVideo = document.getElementById(this.videoId);
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
          return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      var constraints = { audio: false, video: { width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)' } }
      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        _this.videoMode = true;
        _this.toke = false;
        // 旧的浏览器可能没有srcObject
        if ('srcObject' in _this.thisVideo) {
          _this.thisVideo.srcObject = stream
        } else {
          // 避免在新的浏览器中使用它，因为它正在被弃用。
          _this.thisVideo.src = window.URL.createObjectURL(stream)
        }
        _this.thisVideo.onloadedmetadata = function (e) {
          _this.thisVideo.play()
        }
      }).catch(err => {
        _this.$message.error("无法正常启用设备，请确认摄像头连接正常");
        _this.videoMode = false;
        _this.toke = false;
        console.log(err)
      })
    },
    setImage () {
      var _this = this;
      // 点击，canvas画图
      _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
      // 获取图片base64链接
      var image = _this.thisCancas.toDataURL('image/jpg');
      if(_this.sizeLimit) {
        var size = image.length *0.75 / 1024;
        // console.log("size",size);
        if(size > 500) {
          _this.dealImage(image,function(base64) {
            image = base64;
            _this.takeup(image);
            var size_2 = image.length *0.75 / 1024;
            // console.log("size_2",size_2);
          })
        } else {
          _this.takeup(image);
        }
      } else {
        _this.takeup(image);
      }
      this.$emit('set-img')
    },
    takeup(image) {
      var _this = this;
      var file = _this.dataURLtoFile(image,'certUrl');
      var data = new FormData();
      data.append("file", file, 'certUrl.' + file.type.split("/")[1]);
      _this.loading = true;
      for(var item in _this.formData) {
        data.append(item, _this.formData[item]);
      }
      _this.api[_this.uploadApi](data).then(res => {
        _this.loading = false;
        if(res.Code==0) {
          _this.toke = true;
          _this.$emit('input',res.Data);
          _this.stopNavigator();
        } else {
          var tip = res.Code==1?'照片不符合要求，':'上传失败，';
          _this.$message.error(tip + res.Msg);
          _this.delCert();
        }
      })
    },
    dealImage(base64, callback) {
      var newImage = new Image();
      var quality = 1; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", 'Anonymous'); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (imgWidth > 1080 || imgHeight > 1080) {
          if (imgHeight > imgWidth) {
            canvas.height = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.width = canvas.height * ratio;
          } else {
            canvas.width = 1080;
            var ratio = imgWidth / imgHeight;
            canvas.height = canvas.width / ratio;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        // console.log("??!-*",base64.length)
        // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
        while (base64.length *0.75 / 1024 > 500) {
        	quality -= 0.1;
        	base64 = canvas.toDataURL("image/jpeg", quality);
          // console.log("压缩")
        }
        callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
      }
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    stopNavigator () {
      this.$emit('close-video');
      this.thisVideo.srcObject.getTracks()[0].stop();
      this.videoMode = false;
    },
    delCert() {
      this.toke = false;
      this.$emit("input","");
      this.$emit("del-img")
    },
    beforePhotoUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      // if(this.sizeLimit) {
      //   const is500k = file.size/1024 <= 500;
      //   if(!is500k) {
      //     this.$message.error("照片大小不能超过500k")
      //   }
      //   return is500k;
      // }
      this.isLoading = true;
      var _this = this;
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader();
          // 将文件加载进入
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var base64 = reader.result;
            console.log("原", (base64.length * 0.75) / 1024);
            _this.dealImage(base64, function (new_base64) {
              console.log("后", (new_base64.length * 0.75) / 1024);
              var new_file = _this.dataURLtoFile(new_base64, file.name);
              console.log("new_file", new_file);
              resolve(new_file);
            });
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    onSuccess(res) {
      this.isLoading = false;
      if(res.Code==0) {
        this.$emit('input',res.Data);
        this.$emit('set-img');
      } else {
        var tip = res.Code==1?'照片不符合要求，':'上传失败，';
        this.$message.error(tip + res.Msg);
      }
    },
    clear() {
      if(this.videoMode) {
        this.stopNavigator();
      }
      this.thisCancas = null;
      this.thisContext = null;
      this.thisVideo = null;
      // this.videoMode = false;
      this.toke = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.videoPosition {
  position:absolute;
  top: 46px;;
}
.photograph{
    border: 1px solid #DCDFE6;
    margin: auto;
    padding: 8px 15px;
    position: relative;
    i{
        font-size: 28px;
        color: #8c939d;
    }
}
.photo-uploader{
    background: #e2e4e7;
    // position:absolute;
    // top: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-upload--text{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
}
</style>